module.exports = __webpack_public_path__ + "img/roles-permisos.70ff28ef.svg";